import React, { Component } from 'react';
import { Helmet } from 'react-helmet';
import styled, { css } from 'styled-components';
import PropTypes from 'prop-types';
import { Map } from 'immutable';
import connect from '../store/connect';
import { setViewstate } from '../actions/actionCreators';
import Breadcrumbs from '../components/Breadcrumbs';
import Overlay from '../components/Overlay';
import CookieBar from '../components/CookieBar';
import NewsletterWidget from '../components/NewsletterWidget';
import { SITE_ROOT_URL } from '../constants/endpoints';

class Page extends Component {
  constructor(props) {
    super(props);
    this.checkDevice = this.checkDevice.bind(this);
  }

  componentWillMount() {
    this.checkDevice();
  }

  componentDidMount() {
    window.addEventListener('resize', this.checkDevice);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.checkDevice);
  }

  checkDevice() {
    this.props.setViewstate('pageWidth', window.innerWidth);
  }

  render() {
    const { viewstate, meta, canonical } = this.props;
    const pageWidth = viewstate.get('pageWidth');
    const activeMenuItem = viewstate.get('activeMenuItem');

    return (
      <PageContainer bgImg={this.props.bgImg} bgColor={this.props.bgColor} loadingState={this.props.loadingState}>
        <Helmet>
          <title>{meta.get('metaTitle')}</title>
          {meta.get('metaTitle') && <meta name="title" property="og:title" content={meta.get('metaTitle')} />}
          {meta.get('metaDescription') && (
            <meta name="description" property="og:description" content={meta.get('metaDescription')} />
          )}
          {meta.get('imageUrl') && (
            <meta name="image" property="og:image" content={SITE_ROOT_URL + meta.get('imageUrl')} />
          )}
          {meta.get('keywords') && <meta name="keywords" content={meta.get('keywords')} />}
          {meta.get('url') && <meta name="url" content={window.location.origin + meta.get('url')} />}
          {canonical ? <link rel="canonical" href={window.location.origin + canonical} /> : false}
        </Helmet>
        <Breadcrumbs
          pageWidth={pageWidth}
          disabled={this.props.noBreadcrumbs}
          currentItem={this.props.lastBreadcrumbItem}
        />
        {this.props.children}
        <Overlay active={activeMenuItem && typeof activeMenuItem === 'string'} />
        <NewsletterWidget />
        <CookieBar />
      </PageContainer>
    );
  }
}

const PageContainer = styled.div`
  background-color: ${props => (props.bgColor ? props.bgColor : 'transparent')};
  position: relative;
  padding: 0;
  margin: 0;
  ${props =>
    props.bgImg &&
    css`
      background: url(${props.bgImg});
      background-position: center;
      background-size: cover;
    `};
`;

Page.defaultProps = {
  bgColor: '',
  bgImg: '',
  noBreadcrumbs: false,
  lastBreadcrumbItem: null,
  loadingState: false,
  meta: Map(),
  canonical: null
};

Page.propTypes = {
  setViewstate: PropTypes.func.isRequired,
  viewstate: PropTypes.instanceOf(Map).isRequired,
  bgColor: PropTypes.string,
  bgImg: PropTypes.string,
  meta: PropTypes.instanceOf(Map),
  canonical: PropTypes.string,
  noBreadcrumbs: PropTypes.bool,
  lastBreadcrumbItem: PropTypes.object,
  loadingState: PropTypes.bool,
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired
};

export default connect(Page, { setViewstate }, store => ({
  viewstate: store.viewstate
}));



// WEBPACK FOOTER //
// ./src/pages/Page.js